/* Vista previa aproximada del Memory Bunny (Dear Noel).
   Coloca las fotos que sube el cliente sobre el peluche: 4 en el corazón, 1 en cada oreja (sin bordes ni costuras inventados).
   Lee las fotos del selector de archivos de la página (instantáneo) y, si hace falta, de las miniaturas de Uploadly. */
(function () {
  var root = document.querySelector('[data-dn-bunny]');
  if (!root || root.getAttribute('data-ready')) return;
  root.setAttribute('data-ready', '1');

  var GRAY = root.getAttribute('data-gray') !== '0';
  var FORM = root.getAttribute('data-form') || '';
  var COLORS = [['rosa', 'Rosa'], ['blanco', 'Blanco'], ['crema', 'Crema'], ['gris', 'Gris']];
  var IMG = {}; COLORS.forEach(function (c) { IMG[c[0]] = root.getAttribute('data-img-' + c[0]) || ''; });
  var NS = 'http://www.w3.org/2000/svg';

  var GEO = {
    earL: [[225,123],[224,262],[215,295],[183,362],[162,391],[119,423],[100,423],[88,413],[80,393],[78,354],[100,264],[145,176],[169,147],[194,124]],
    earR: [[465,126],[504,130],[523,144],[577,223],[601,269],[620,336],[625,380],[618,406],[607,423],[596,429],[560,422],[532,399],[496,351],[470,297],[463,267]]
  };
  var ADJ = {
    rosa:   { earL: [0, 0, 1.05], earR: [0, 0, 1.05], heart: [0, 0, 1.06] },
    blanco: { earL: [0, 0, 1.05], earR: [0, 0, 1.05], heart: [0, 1, 1.06] },
    crema:  { earL: [0, 0, 1.05], earR: [0, 0, 1.05], heart: [-3, -3, 1.09] },
    gris:   { earL: [0, 0, 1.05], earR: [0, 0, 1.05], heart: [-1, 1, 1.08] }
  };
  var EAR = { earL: { ang: 24, w: 150, h: 330 }, earR: { ang: -23, w: 150, h: 330 } };

  var color = 'rosa', photos = [];
  var css = '[data-dn-bunny]{margin:10px 0 18px}.dnb-wrap{border:1px solid #eadfd0;border-radius:18px;padding:14px;background:#fff}' +
    '.dnb-h{font-weight:600;margin:0 0 8px;font-size:1.5rem}.dnb-svg{width:100%;height:auto;display:block;border-radius:14px;background:#f3e9db}' +
    '.dnb-chips{display:flex;gap:8px;flex-wrap:wrap;margin:10px 0}.dnb-chip{border:1.5px solid #eadfd0;border-radius:99px;padding:6px 14px;background:#fff;cursor:pointer;font-size:1.3rem;color:#3b2a20}' +
    '.dnb-chip.on{border-color:#7a1f2b;background:#fbf6ef;font-weight:600}.dnb-note{font-size:1.2rem;color:#7a6a5e;margin:6px 0 0;line-height:1.4}' +
    '.dnb-leg{display:flex;gap:6px;flex-wrap:wrap;margin-top:8px}.dnb-leg span{font-size:1.15rem;background:#f3e9db;border-radius:99px;padding:2px 10px;color:#3b2a20}' +
    '.dnb-reset{margin-top:8px;background:none;border:0;color:#7a1f2b;text-decoration:underline;cursor:pointer;font-size:1.25rem;padding:0}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function el(n, a, p) { var e = document.createElementNS(NS, n); for (var k in a) e.setAttribute(k, a[k]); if (p) p.appendChild(e); return e; }
  function ctr(arr) { var xs = arr.map(function (p) { return p[0]; }), ys = arr.map(function (p) { return p[1]; }); return [(Math.min.apply(0, xs) + Math.max.apply(0, xs)) / 2, (Math.min.apply(0, ys) + Math.max.apply(0, ys)) / 2]; }
  function tf(arr, adj) { var c = ctr(arr); return arr.map(function (p) { return [c[0] + (p[0] - c[0]) * adj[2] + adj[0], c[1] + (p[1] - c[1]) * adj[2] + adj[1]]; }); }
  function pts(arr, adj) { return tf(arr, adj).map(function (p) { return p[0].toFixed(1) + ',' + p[1].toFixed(1); }).join(' '); }
  function bbox(arr, adj) {
    var q = tf(arr, adj), xs = q.map(function (p) { return p[0]; }), ys = q.map(function (p) { return p[1]; });
    var x0 = Math.min.apply(0, xs), x1 = Math.max.apply(0, xs), y0 = Math.min.apply(0, ys), y1 = Math.max.apply(0, ys);
    return { x: x0, y: y0, w: x1 - x0, h: y1 - y0, cx: (x0 + x1) / 2, cy: (y0 + y1) / 2 };
  }

  var box = document.createElement('div'); box.className = 'dnb-wrap';
  box.innerHTML = '<p class="dnb-h">Así se verá tu Memory Bunny <span style="font-weight:400;color:#7a6a5e">(aproximado)</span></p>';
  var svgHost = document.createElement('div'); box.appendChild(svgHost);
  var chips = document.createElement('div'); chips.className = 'dnb-chips'; box.appendChild(chips);
  var leg = document.createElement('div'); leg.className = 'dnb-leg';
  leg.innerHTML = '<span>Fotos 1 a 4: corazón</span><span>Foto 5: oreja izquierda</span><span>Foto 6: oreja derecha</span>'; box.appendChild(leg);
  var note = document.createElement('p'); note.className = 'dnb-note';
  note.textContent = 'Vista previa orientativa: el resultado final puede variar un poco en recorte y tono.' + (GRAY ? ' Las fotos se imprimen en blanco y negro.' : ''); box.appendChild(note);
  var reset = document.createElement('button'); reset.type = 'button'; reset.className = 'dnb-reset'; reset.textContent = 'Quitar las fotos de la vista previa'; reset.style.display = 'none'; box.appendChild(reset);
  root.appendChild(box);

  var hid = document.createElement('input'); hid.type = 'hidden'; hid.name = 'properties[Color]'; if (FORM) hid.setAttribute('form', FORM); root.appendChild(hid);

  function draw() {
    svgHost.innerHTML = '';
    var svg = el('svg', { viewBox: '0 0 720 720', 'class': 'dnb-svg', role: 'img', 'aria-label': 'Vista previa del conejo con tus fotos' }); svgHost.appendChild(svg);
    el('image', { href: IMG[color], x: 0, y: 0, width: 720, height: 720 }, svg);
    var defs = el('defs', {}, svg), adj = ADJ[color] || ADJ.rosa;
    var filt = GRAY ? 'filter:grayscale(1) contrast(1.05)' : '';
    function zone(id, arr, a) { var cp = el('clipPath', { id: 'dnb-' + id }, defs); el('polygon', { points: pts(arr, a) }, cp); }
    zone('L', GEO.earL, adj.earL); zone('R', GEO.earR, adj.earR);
    function slotNum(x, y, n, filled, par) {
      if (filled) return;
      var g = el('g', {}, par || svg);
      el('circle', { cx: x, cy: y, r: 16, fill: '#7a1f2b', opacity: 0.85 }, g);
      var t = el('text', { x: x, y: y + 6, 'text-anchor': 'middle', fill: '#fff', 'font-size': 18, 'font-weight': 700, 'font-family': 'sans-serif' }, g); t.textContent = n;
    }
    // corazón: 4 fotos pegadas, sin bordes ni líneas blancas (path bezier, sin huecos)
    var HP = 'M346,593 C300,552 247,500 247,438 C247,400 275,380 303,380 C327,380 342,396 346,427 C350,396 365,380 389,380 C417,380 445,400 445,438 C445,500 392,552 346,593 Z';
    var ha = adj.heart, hT = 'translate(' + (346 + ha[0]) + ',' + (486.5 + ha[1]) + ') scale(' + ha[2] + ') translate(-346,-486.5)';
    var hd = el('defs', {}, svg);
    var cpH = el('clipPath', { id: 'dnb-H' }, hd); el('path', { d: HP }, cpH);
    var fi = el('filter', { id: 'dnb-in', x: '-10%', y: '-10%', width: '120%', height: '120%' }, hd);
    el('feGaussianBlur', { stdDeviation: 5 }, fi);
    var ft = el('filter', { id: 'dnb-tx', x: 0, y: 0, width: '100%', height: '100%' }, hd);
    el('feTurbulence', { type: 'fractalNoise', baseFrequency: 0.9, numOctaves: 2, seed: 4, result: 'n' }, ft);
    el('feColorMatrix', { type: 'matrix', values: '0 0 0 0 0.45  0 0 0 0 0.38  0 0 0 0 0.33  0 0 0 1.1 -0.25' }, ft);
    var rg = el('radialGradient', { id: 'dnb-vg', cx: 0.5, cy: 0.42, r: 0.65 }, hd);
    el('stop', { offset: 0, 'stop-color': '#fff', 'stop-opacity': 0.15 }, rg); el('stop', { offset: 0.6, 'stop-color': '#fff', 'stop-opacity': 0 }, rg); el('stop', { offset: 1, 'stop-color': '#4a3328', 'stop-opacity': 0.2 }, rg);
    var gW = el('g', { transform: hT }, svg);
    var gH = el('g', { 'clip-path': 'url(#dnb-H)' }, gW);
    el('rect', { x: 230, y: 365, width: 232, height: 240, fill: '#b9b2ab' }, gH);
    var Z = [[225, 365, 121, 108], [346, 365, 121, 108], [225, 473, 121, 135], [346, 473, 121, 135]];
    var nums = [];
    Z.forEach(function (q, i) {
      if (photos[i]) el('image', { href: photos[i].src, x: q[0], y: q[1], width: q[2], height: q[3], preserveAspectRatio: 'xMidYMid slice', style: filt }, gH);
    });
    el('rect', { x: 230, y: 365, width: 232, height: 240, fill: 'url(#dnb-vg)' }, gH);
    el('rect', { x: 230, y: 365, width: 232, height: 240, filter: 'url(#dnb-tx)', opacity: 0.16, style: 'mix-blend-mode:multiply' }, gH);
    el('path', { d: HP, fill: 'none', stroke: '#3b2a20', 'stroke-width': 9, opacity: 0.3, filter: 'url(#dnb-in)' }, gH);
    [[296, 428], [396, 428], [306, 515], [386, 515]].forEach(function (c, i) { slotNum(c[0], c[1], i + 1, !!photos[i], gW); });
    // orejas: una foto por oreja, inclinada como la oreja
    [['earL', 'L', 4], ['earR', 'R', 5]].forEach(function (z) {
      var a = adj[z[0]], b = bbox(GEO[z[0]], a), g = el('g', { 'clip-path': 'url(#dnb-' + z[1] + ')' }, svg), p = photos[z[2]], E = EAR[z[0]];
      el('polygon', { points: pts(GEO[z[0]], a), fill: 'rgba(255,255,255,.55)' }, g);
      if (p) el('image', { href: p.src, x: b.cx - E.w / 2, y: b.cy - E.h / 2, width: E.w, height: E.h, preserveAspectRatio: 'xMidYMid slice', transform: 'rotate(' + E.ang + ' ' + b.cx + ' ' + b.cy + ')', style: filt }, g);
      nums.push([b.cx, b.cy, z[2] + 1, !!p]);
    });
    nums.forEach(function (n) { slotNum(n[0], n[1], n[2], n[3]); });
    reset.style.display = photos.length ? '' : 'none';
  }

  function drawChips() {
    chips.innerHTML = '';
    COLORS.forEach(function (c) {
      if (!IMG[c[0]]) return;
      var b = document.createElement('button'); b.type = 'button'; b.className = 'dnb-chip' + (c[0] === color ? ' on' : ''); b.textContent = c[1];
      b.addEventListener('click', function () { color = c[0]; drawChips(); draw(); }); chips.appendChild(b);
    });
    hid.value = (COLORS.filter(function (c) { return c[0] === color; })[0] || [0, ''])[1];
  }

  function addFiles(files) {
    Array.prototype.slice.call(files || []).forEach(function (f) {
      if (!/^image\//.test(f.type) || photos.length >= 6) return;
      photos.push({ src: URL.createObjectURL(f), local: true });
    });
    draw();
  }
  document.addEventListener('change', function (e) { var t = e.target; if (t && t.type === 'file' && t.files && t.files.length) addFiles(t.files); }, true);
  document.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) addFiles(e.dataTransfer.files); }, true);
  reset.addEventListener('click', function () { photos = []; draw(); });

  var app = document.getElementById('photouploadapp');
  if (app && window.MutationObserver) {
    new MutationObserver(function () {
      if (photos.some(function (p) { return p.local; })) return;
      var imgs = Array.prototype.slice.call(app.querySelectorAll('[id^="previewImages_"] img')).map(function (i) { return i.src; }).filter(Boolean).slice(0, 6);
      if (imgs.length && imgs.join() !== photos.map(function (p) { return p.src; }).join()) { photos = imgs.map(function (s) { return { src: s }; }); draw(); }
    }).observe(app, { childList: true, subtree: true });
  }

  window.DNBunny = { add: addFiles, setColor: function (c) { color = c; drawChips(); draw(); }, adj: ADJ, ear: EAR, redraw: draw };
  drawChips(); draw();
})();
